import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import media from "../../utils/mediaQueries"
import { white, smoke } from "../../utils/colors"

import Logo from "../../images/MindMeLogo.svg"
const { se, desktop } = media

const Header = () => (
  <StyledHeader>
    <StyledHeaderContainer>
      <LogoWrapper>
        <Link to="/">
          <StyledImg src={Logo} alt="MindMe Logo" />
        </Link>
      </LogoWrapper>
      <StyledNav>
        <StyledNavList>
          <StyledNavListItem>Web</StyledNavListItem>
          {/* <StyledNavListItem>iOS</StyledNavListItem>
          <StyledNavListItem>Android</StyledNavListItem> */}
        </StyledNavList>
      </StyledNav>
    </StyledHeaderContainer>
  </StyledHeader>
)

export default Header

const StyledHeader = styled.header`
  ${se && se`
    display: none;
  `}
  ${desktop &&
    desktop`
    display: block;
      position: absolute;
      z-index: 40;
      top: 0;
      width: 100%;
`}
`

const StyledHeaderContainer = styled.div`
  ${desktop &&
    desktop`
      position: relative;
      display: flex;
`}
`

const LogoWrapper = styled.div`
    background-color: ${props => (props.theme.sidebar)};

${se && se`
  width: 100%;
  padding: 10px;
`}

  ${desktop &&
    desktop`
      width: 330px;
      padding: 10px 30px;
      border-bottom: 1px solid ${props => (props.theme.border)};
`}
`

const StyledImg = styled.img`
  margin-bottom: 0;
  ${se && se`
   width: 40%;
   max-width: 200px;
  `}

  ${desktop &&
    desktop`
      width: 150px;
`}
`

const StyledNav = styled.nav`
${se && se`
  display: none;
`}
  ${desktop &&
    desktop`
    display: flex;
    background-color: ${props => (props.theme.bg)};
    border-bottom: 1px solid ${props => (props.theme.border)};
    flex-grow: 1;

  `}
`

const StyledNavList = styled.ul`
  margin-bottom: 0;
  height: 100%;
  ${desktop &&
    desktop`
    display: flex;
  `}
`

const StyledNavListItem = styled.li`
  list-style: none;
  margin-left: 16px;
  margin-right: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
  margin-bottom: 0;
  color: ${props => (props.theme.text)};
`
